import cookie from 'js-cookie';

import events from '../events';

const COOKIE_EXPIRE_DAYS = 30;
const COOKIE_NAME = 'slxcom-hpinfo';
const COOKIE_VALUE = '2';

let popup;

function start() {
	popup = document.query('.slx-popup');
	if (popup) {
		// open on load, if cookie is not set
		let doShowInfo = cookie.get(COOKIE_NAME) !== COOKIE_VALUE;
		if (doShowInfo) {
			// only show once
			cookie.set(COOKIE_NAME, COOKIE_VALUE, {expires: COOKIE_EXPIRE_DAYS});
			events.emit('openLayout', popup);
		}
	}
}

start();
